import styled from 'styled-components';

export const MapWrapper = styled.div`
  .rsm-geography { pointer-events: none; outline: none; }
  .markerLink:focus .marker-tooltip, .markerLink:hover .marker-tooltip { visibility: visible; }
  .markerLink, .markerLink:focus, .markerLink:focus-visible, .rsm-marker { outline: none !important; }
  .markerLink:focus-visible > .rsm-marker > svg { filter: drop-shadow(0 0 3px #2c5bff); }
  width: 98%;
  max-width: 1098px;
  margin: 0px auto;
`;
